<template>
  <panel :title="title">
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.subject" />
      </div>

      <div class="form-group col-6">
        <w-input :model="$schema.fromName" />
      </div>

      <div class="form-group col-6">
        <w-input :model="$schema.fromAddress" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.to" />
      </div>

      <div class="form-group col-12">
        <w-monaco language="html" :model="$schema.body" />
      </div>
    </div>

    <div slot="footer" class="row">
      <div class="col-md-12">
        <button class="btn btn-secondary float-left" @click="cancel">
          Anuluj
        </button>

        <button class="btn btn-primary float-right" @click="save">
          Zapisz
        </button>
      </div>
    </div>
  </panel>
</template>

<script>
import Panel from '@/components/panel/Panel';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/mailTemplate.schema';

const emptyData = () => ({
  name: null,
  subject: null,
  fromName: null,
  fromAddress: null,
  to: null,
  body: null
});
const messages = {
  listError: Errors.MAIL_TEMPLATE_CANNOT_LIST,
  getError: Errors.MAIL_TEMPLATE_CANNOT_GET,
  added: Successes.MAIL_TEMPLATE_ADDED,
  addError: Errors.MAIL_TEMPLATE_ADD_ERROR,
  updated: Successes.MAIL_TEMPLATE_UPDATED,
  updateError: Errors.MAIL_TEMPLATE_UPDATE_ERROR,
  deleteConfirm: Successes.MAIL_TEMPLATE_CONFIRM_DELETE,
  deleted: Successes.MAIL_TEMPLATE_DELETED,
  deleteError: Errors.MAIL_TEMPLATE_DELETE_ERROR
};

// @vuese
// Formularz dodawania/edycji szablonów wiadomości e-mail
// @group Forms
export default {
  components: { Panel },
  mixins: [formViewMixin('mailTemplate', messages, emptyData)],
  schema,
  computed: {
    title() {
      return this.edit ? 'Edycja szablonu wiadomości e-mail' : 'Dodawanie szablonu wiadomości e-mail';
    }
  },

  methods: {
    // @vuese
    // Funkcja wykonywana po zapisie
    afterSave(data) {
      this.$emit('saved', data);
    }
  }
};
</script>
